export function AddAttachment(organizationID: number, ID: number, attachmentID: number): string {
	return `/v1/organizations/${organizationID}/performance-reviews/${ID}/attachments/${attachmentID}`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/performance-reviews`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/performance-reviews/${ID}`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/performance-reviews`;
}

export function RemoveAttachment(organizationID: number, ID: number, attachmentID: number): string {
	return `/v1/organizations/${organizationID}/performance-reviews/${ID}/attachments/${attachmentID}`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/performance-reviews/${ID}`;
}

